import { render, staticRenderFns } from "./ZinusNoticeWebpart.vue?vue&type=template&id=1d2ccd44&scoped=true"
import script from "./ZinusNoticeWebpart.ts?vue&type=script&lang=ts&external"
export * from "./ZinusNoticeWebpart.ts?vue&type=script&lang=ts&external"
import style0 from "./ZinusNoticeWebpart.vue?vue&type=style&index=0&id=1d2ccd44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2ccd44",
  null
  
)

export default component.exports